// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsExtrapolation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s32IconSvg = html `<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M16.0001 32C23.7684 32 30.2437 26.4639 31.6957 19.1218L29.1304 20.8686C27.1526 26.2004 22.0201 30 16.0001 30 9.91936 30 4.74406 26.1233 2.81093 20.7066L.256794 18.8699C1.6091 26.3369 8.14327 32 16.0001 32ZM16.0001 0C23.8569 0 30.391 5.663 31.7434 13.1299L29.1893 11.2933C27.2561 5.87664 22.0808 2 16.0001 2 9.98009 2 4.84753 5.79965 2.86981 11.1316L.304468 12.8784C1.7565 5.5362 8.23178 0 16.0001 0Z" class="svg-bg"/>
  <path d="M15.1533 12.2568C15.1533 11.7046 15.601 11.2568 16.1533 11.2568 16.7056 11.2568 17.1533 11.7046 17.1533 12.2568 17.1533 12.8091 16.7056 13.2568 16.1533 13.2568 15.601 13.2568 15.1533 12.8091 15.1533 12.2568ZM11.5 15.5C11.5 14.3954 12.3954 13.5 13.5 13.5 14.6046 13.5 15.5 14.3954 15.5 15.5 15.5 16.6046 14.6046 17.5 13.5 17.5 12.3954 17.5 11.5 16.6046 11.5 15.5ZM19.3271 13.0548C18.7749 13.0548 18.3271 13.5025 18.3271 14.0548 18.3271 14.6071 18.7749 15.0548 19.3271 15.0548 19.8794 15.0548 20.3271 14.6071 20.3271 14.0548 20.3271 13.5025 19.8794 13.0548 19.3271 13.0548ZM17.5 19.5C17.5 18.9477 17.9477 18.5 18.5 18.5 19.0523 18.5 19.5 18.9477 19.5 19.5 19.5 20.0523 19.0523 20.5 18.5 20.5 17.9477 20.5 17.5 20.0523 17.5 19.5ZM17 15.9304C16.4477 15.9304 16 16.3781 16 16.9304 16 17.4827 16.4477 17.9304 17 17.9304 17.5523 17.9304 18 17.4827 18 16.9304 18 16.3781 17.5523 15.9304 17 15.9304ZM13.5 19C13.5 18.4477 13.9477 18 14.5 18 15.0523 18 15.5 18.4477 15.5 19 15.5 19.5523 15.0523 20 14.5 20 13.9477 20 13.5 19.5523 13.5 19Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 16C24 20.4183 20.4183 24 16 24C11.5817 24 8 20.4183 8 16C8 11.5817 11.5817 8 16 8C20.4183 8 24 11.5817 24 16ZM22 16C22 19.3137 19.3137 22 16 22C12.6863 22 10 19.3137 10 16C10 12.6863 12.6863 10 16 10C19.3137 10 22 12.6863 22 16Z" class="svg-bg"/>
  <path d="M0 15.9182 4 13V15H6V17H4V19L0 15.9182ZM32 16.0818 28 19V17H26V15H28V13L32 16.0818Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsExtrapolation is a generated icon component.
 */
let IconRmsExtrapolation = IconRmsExtrapolation_1 = class IconRmsExtrapolation extends IconBaseElement {
    render() {
        return html `${IconRmsExtrapolation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsExtrapolation.icons = new Map([
    ['s8', _s32IconSvg],
    ['s12', _s32IconSvg],
    ['s16', _s32IconSvg],
    ['s24', _s32IconSvg],
    ['s32', _s32IconSvg],
    ['s40', _s32IconSvg],
    ['s48', _s32IconSvg],
    ['s64', _s32IconSvg],
    ['s72', _s32IconSvg],
    ['s80', _s32IconSvg],
]);
IconRmsExtrapolation = IconRmsExtrapolation_1 = __decorate([
    customElement('zui-icon-rms-extrapolation')
], IconRmsExtrapolation);
export { IconRmsExtrapolation };
